import React from 'react';
import { ReactSVG } from 'react-svg';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { IMAGE_PATH } from 'common/ImageConstants/ImagePathUtils';
import { TRANSLATE_MAPPING_KEY } from 'common/constants/i18nTranslateKeys';

const OffersCoupon = props => {
  const { discountAmounts } = props;
  const { PROMOS_REWARDS } = TRANSLATE_MAPPING_KEY;
  const { Promos_Coupon_Icon } = IMAGE_PATH;

  const getPromosTitles = () => {
    return discountAmounts?.map(item => item.title).join(', ');
  };

  return (
    <div className='cart-offers-container cart-coupon-offers-container' data-testid='cart-offers-coupon'>
      <div className='cart-offers-link'>
        <ReactSVG src={Promos_Coupon_Icon} alt='' className='cart-offers-icon' />
        <span className='cart-offers-text'>{translateWithI18Next(PROMOS_REWARDS)}</span>
      </div>
      <div class='cart-coupon-offers-text'>{getPromosTitles()}</div>
    </div>
  );
};

export default OffersCoupon;
